import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { documentValidation } from './validation'

export const useDocumentForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(documentValidation()),
    initialValues: {
      new_document_ktp: null,
      recent_document_ktp: null,
      new_document_selfie_ktp: null,
      recent_document_selfie_ktp: null,
      verified_status: '50',
    }
  })
}
